import { Stars } from '@react-three/drei'
import Lights from './Lights.js'
import {Level} from './Level.js'
import {Debug, Physics} from '@react-three/rapier'
import Player from './Player.js'
import useGame from './stores/useGame.js'
import Effects from './Effects.js'


export default function Experience()
{
    
    const blockCount = useGame((state) =>  state.blocksCount)
    const blocksSeed = useGame((state) =>  state.blockSeed)

    return <>

        <color args={ [ '#252731' ] } attach="background" />

        <Physics>
        <Effects />
            {/* <Debug /> */}
            <Lights />
            <Level count={blockCount} seed={blocksSeed}/>
            <Player/>
        </Physics>
      
        <Effects />

    </>
}


